module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAVdJREFUKBWdkj2LwkAQhl+PE2OR1iZlkDQphIBNQIhFsAr+DsFflsIUAbGw10ZBsLCLKGqiWCgS/IjezYJ7ya1Y+DY7M5lnZjOzucev8IG+PmAY8v0KXCwW8H0fmqZhNpvBcRwoipJJfdmx1+uhXC6jXq+zs9vtZiByBHA+n2M4HCIIAkynU3YOBgMsl8sMnPs/HNd1QXA+n0ccx5AkCUmSQFVVNJtNDgsda7UadrsdzuczVqsVLpcLttstKJ6WAK7Xa9xuN0RRhEKhwCDyqUhawlQrlQpLKhaLsCwL/X4f1+sVuq6nOQggfR2NRiiVSgjDEPv9HsfjEY1G4z1Iiff7HdVqlSd2Oh0Gy7LMY0LHyWQCwzBAV36Kpkxx0zSfIfGqtILD4ZDZ2+l0Av1zWkLH8XjMdud5Hs+jYpvNBrZt8xjoAaTVarXSLrfb7Ta3yRBezl/J99YPkIPOfFS8yKAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/kids.png
// module id = 508
// module chunks = 0